const codes = [
	// Screening Module Privileges
	'GET_BATCHES',
	'CREATE_BATCH',
	'UPDATE_BATCH',
	'GET_ELIGIBLE_CANDIDATES_FOR_NEXT_BATCH',
	'GET_APPLICATIONS',
	'GET_APPLICATION',
	'GET_PROPOSER_LOAD_SUMMARY',
	'GET_ZONES_PROPOSER_LOAD_SUMMARY',
	'GET_CANDIDATES_LOAD_SUMMARY',
	'REASSIGN_FUNCTIONARY_TO_APPLICATION',
	'BULK_ASSIGN_FUNCTIONARY_TO_APPLICATION_FOR_REGION',
	'GET_CANDIDATE_SCREENING_PROGRESS_SUMMARY',
	'UPDATE_REGION_ZONE_CENTER_OF_APPLICATION',
	'GET_CENTRAL_TEAM_DASHBOARD_DETAIL',
	'GET_PREWORK_APPLICATIONS',
	'SUBMIT_APPROVER_PREWORK_RECOMMENDATION',
	'CAPTURE_PREWORK_MENTOR_ANSWERS',

	// Manage Functionaries Privileges
	'BULK_UPLOAD_FUNCTIONARIES',
	'BULK_SAVE_FUNCTIONARIES_OF_ZONE',
	'DOWNLOAD_TEMPLATE_FOR_BULK_UPLOAD_FUNCTIONARIES',
	'CREATE_OR_UPDATE_POSITION_ASSIGNMENT',
	'GET_SIGNED_URL',
	'REGISTER_FUNCTIONARY',

	// Exam Module Privileges
	'CREATE_EXAM',
	'GET_EXAMINATION_GRAPHICAL_VIEW',
	'GET_EXAM_RESULT_GRAPHICAL_VIEW',
	'IMPORT_ELIGIBLE_CANDIDATES_FOR_EXAM',
	'SEND_EXAM_REGISTRATION_INVITE_EMAIL',
	'SEND_EXAM_ADMIT_CARD_EMAIL',
	'SEND_EXAM_RESULT_EMAIL',
	'DOWNLOAD_CANDIDATE_EXAMINATION_DETAILS',
	'UPLOAD_EXAM_RESULTS',
	'UPDATE_EXAM',
	'PLACE_CANDIDATE_ON_HOLD',
	'CHANGE_EXAMINATION_CENTER',
	'APPROVE_HELD_CANDIDATE',
	'CREATE_EXAMINATION_CENTER',
	'UPDATE_EXAMINATION_CENTER',
	'CREATE_KANHA_BATCH',
	'UPDATE_KANHA_BATCH',
	'IMPORT_ELIGIBLE_CANDIDATES_FOR_KANHA_BATCH',
	'SEND_KANHA_BATCH_INVITE_EMAIL',
	'DOWNLOAD_KANHA_BATCH_CANDIDATE_DETAILS',
	'UPLOAD_KANHA_BATCH_RESULTS',

	// New Preceptor Module Privileges
	'GET_PRECEPTOR_BATCHES',
	'CREATE_PRECEPTOR_GROUP',
	'ASSIGN_MENTOR',
	'CREATE_PRECEPTOR_BATCH',
	'DELETE_PRECEPTOR_GROUPS',
	'GET_GRAPHICAL_VIEW',
	'GET_PRECEPTOR_DASHBOARD_CARD_DETAIL',
	'GET_PRECEPTOR_GROUPS',
	'GET_PRECEPTOR_GROUP',
	'GET_REGIONS_OF_LOGGED_IN_PRECEPTOR',
	'LOAD_PRECEPTORS_FROM_MYSRCM',
	'UPDATE_PRECEPTOR_BATCH',
	'GET_PRECEPTORS',
	'UPDATE_PRECEPTOR_GROUP',

	// Prework Module Privileges
	'CREATE_PREWORK_GROUP',
	'GET_PREWORK_CANDIDATES',
	'GET_PREWORK_GROUPS',
	'GET_PREWORK_GROUP',
	'UPDATE_PREWORK_GROUP',
	'ASSIGN_PREWORK_MENTOR',
	'GET_PREWORK_GRAPHICAL_VIEW',
	'GET_PREWORK_DASHBOARD_METRICS',
];

export const PrivilegeCodes = Object.fromEntries(
	codes.map((code) => [code, code])
) as Record<(typeof codes)[number], (typeof codes)[number]>;
